import { generatePath } from 'react-router-dom';

import { ErrorLoading } from '@packages/fenrir/feedback/errors/error-loading';
import { PageContainerRoot } from '@packages/fenrir/page-blocks/page-container/page-container-root';
import { PagePlain } from '@packages/fenrir/pages/page-plain';

// TODO: S2CX-15999: Move hard coded text to translations when @platform/core/locale/i18n is enabled
export const LoadingErrorPage = () => {
  const actionProps = {
    label: 'Return to Homepage',
    to: generatePath('/'),
  };

  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <PagePlain>
      <PageContainerRoot>
        <ErrorLoading actionLink={actionProps} reloadOnClick={refreshPage} />
      </PageContainerRoot>
    </PagePlain>
  );
};
